module.exports = __webpack_public_path__ + "c3c3c923.svg";


//////////////////
// WEBPACK FOOTER
// ./src/desktop/components/SearchInput/search.svg
// module id = 2450
// module chunks = 1 36